import HowToGetHiveonOs from './HowToGetHiveonOs';

export default HowToGetHiveonOs;